<template>
  <PhoneForm phoneType="new"></PhoneForm>
</template>

<script>
import PhoneForm from '../phoneForm';
export default {
  components: {
    PhoneForm,
  },
};
</script>

<style></style>
